import { HEAVY_TRUCK_TRANSMISSION_LABELS } from '@/features/attributes/constants/attributeTranslationKeys'

/**
 * Returns the i18n translation key for a given heavy truck transmission type.
 *
 * @param transmissionTypeKey - The key representing the transmission type.
 *   Should be one of the values defined in `HEAVY_TRUCK_TRANSMISSION_VALUES`.
 * @returns The corresponding i18n translation key string.
 *
 * @example
 * getHeavyTruckTransmissionTranslation('manual-gear');
 * // Returns: 'listing:attributes.heavy_truck_transmission.manual'
 */
export const getHeavyTruckTransmissionTranslation = (transmissionTypeKey: string) => {
  return HEAVY_TRUCK_TRANSMISSION_LABELS[transmissionTypeKey]
}
